/**
 * After a successful service-request modal submit (`POST /v1/public/service-requests`),
 * also append to the in-browser demo inbox (optional).
 * REACT_APP_PUBLIC_SERVICE_MIRROR_LOCAL=true
 */
export function mirrorPublicServiceRequestToLocal() {
  return (
    String(process.env.REACT_APP_PUBLIC_SERVICE_MIRROR_LOCAL || "")
      .toLowerCase()
      .trim() === "true"
  );
}

/**
 * After a successful contact form submit (`POST /v1/public/contact-messages`),
 * also append to the in-browser demo inbox (optional).
 * REACT_APP_PUBLIC_CONTACT_MIRROR_LOCAL=true
 */
export function mirrorPublicContactMessageToLocal() {
  return (
    String(process.env.REACT_APP_PUBLIC_CONTACT_MIRROR_LOCAL || "")
      .toLowerCase()
      .trim() === "true"
  );
}
